import { Button, Center, CloseButton, Divider, Flex, LoadingOverlay, Text } from "@mantine/core"
import React from "react"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import { DeliveryApi } from "../../apis"
import { IRolePermission } from '../../models/RolePermission'
import { IAuth } from '../../store/Auth'
import { message } from "../../utils/message"
import { FormLayout } from "../layout"
import { backendMessageKey } from "../order/backend-messages"

export function SupplierSplitForm({
  action,
  onCancel,
  reload,
  setChecked,
  success,
}: {
  action: any[]
  onCancel: () => void
  reload: any
  setChecked?: any
  success: () => void
}) {
  const { t } = useTranslation(["supplierSales", "common"])
  const [loading, setLoading] = React.useState<boolean>(false)
  const { user } = useSelector((state: { auth: IAuth }) => state.auth)

  const onSubmit = async () => {
    setLoading(true)
    try {
      await DeliveryApi.create([...action[1]?.map((c: any) => c.id)])
      setChecked([])
      setLoading(false)
      message.success(t("supplierSales:customer.requestSuccess"))
      reload()
      onCancel && onCancel()
      success()
    } catch (error: any) {
      message.error(backendMessageKey(error.message) || t("common:messages.error"))
    }
    setLoading(false)
  }

  return (
    <FormLayout title={t("supplierSales:split.distributeTitle")} my={20} extra={[<CloseButton key="cancel" onClick={() => onCancel && onCancel()} />]}>
      <LoadingOverlay visible={loading} />

      <Divider color="gray.5" my={20} />

      <Center>
        <Text fw={500} fz={24} c="gray.7">
          {t("supplierSales:split.distributeQuestion")}
        </Text>
      </Center>

      <Center>
        <Text fw={500} fz={18} c="gray.7">
          {t("supplierSales:split.distributeConfirm")}
        </Text>
      </Center>

      <Divider color="gray.5" my={20} />

      <Flex direction="row" justify="space-between">
        <Button variant="outline" onClick={() => onCancel && onCancel()}>
          {t("supplierSales:split.cancel")}
        </Button>

        {(user?.permissions || []).filter((c: IRolePermission) => c.module === "ORDER" && c.code === "ORD_DN_ASSIGN").length > 0 && (
          <Button variant="filled" onClick={() => onSubmit()}>
            {t("supplierSales:split.approve")}
          </Button>
        )}
      </Flex>
    </FormLayout>
  )
}
